export class PlaceTransformer {
  static transform (obj) {
    let place = {}

    place.id = obj.id
    place.name = obj.attributes.name
    place.code = obj.attributes.code
    place.type = obj.attributes.type
    place.density = obj.attributes.density
    place.status = obj.attributes.status

    return place
  }
}



// WEBPACK FOOTER //
// ./src/helpers/places/place.transformer.js